import Vue from "vue";
import {
  Form,
  Field,
  Button,
  Radio,
  RadioGroup,
  Cell,
  CellGroup,
  Calendar,
  Popup,
  Picker,
  Toast,
  Checkbox,
  Icon,
  Dialog,
  Cascader,
  Collapse,
  CollapseItem
} from "vant";

[
  Form,
  Field,
  Button,
  Radio,
  RadioGroup,
  Cell,
  CellGroup,
  Calendar,
  Popup,
  Picker,
  Toast,
  Checkbox,
  Icon,
  Dialog,
  Cascader,
  Collapse,
  CollapseItem
].forEach(e => {
  Vue.use(e);
});
